<script lang="ts" setup>
import EventPublicWrapper from "../EventPublic/EventPublicWrapper.vue";
import { Head, usePage } from "@inertiajs/vue3";
import { inject, onMounted, onUnmounted } from "vue";

// interface Props {
//     event: object;
//     iframe_url: string;
// }

// const props = withDefaults(defineProps<Props>(), {});

let iframe_src = "/";

// do not run in SSR
if (typeof window !== "undefined") {
    iframe_src = usePage().props.iframe_url + window.location.hash;
}

onMounted(() => {});

onUnmounted(() => {});
</script>

<template>
    <EventPublicWrapper>
        <Head>
            <title>Event live tracking: {{ $page.props.event.name }}</title>

            <meta
                property="og:title"
                head-key="og:title"
                :content="`Event live tracking: ${$page.props.meta_event_name}`"
            />
        </Head>
        <template #map>
            <iframe
                :src="iframe_src"
                allowfullscreen=""
                webkitallowfullscreen=""
                mozallowfullscreen=""
                class="content-full-screen-height-mt-4 min-h-[50vh] flex-1 rounded-lg bg-white shadow-lg"
            ></iframe>
        </template>
    </EventPublicWrapper>
</template>
